export const getReviewers = `
    query getReviewers($isActive: Boolean) {
        getReviewers(isActive: $isActive) {
            reviewers {
                id
                name
                lastAssignedDate
                type
                total
                submitted
                isActive
                nameN
                isAdmin
                experience  
                programId
                firstName
                lastName
                cancelled
                groupType
                jobType
                pending
                goals
            }
            columns {
                field
                headerName
                flex
                renderCell
            }
        }
    }
`;

export const getOneReviewer = `
    query getOneReviewer($employeeId: ID!) {
        getOneReviewer(employeeId: $employeeId) {
            reviewer {
                id
                name
                experience  
                firstName
                lastName
                groupType
                jobType
                goals
                programId
            }
            experiences
            jobTypes
            groupTypes
        }
    }
`;

export const updateReviewer = `
    mutation updateReviewer($input: UpdateReviewerInput!) {
        updateReviewer(input: $input) {
            status
        }
    }
`;

export const toggleActiveStatus = `
    mutation toggleActiveStatus($reviewerEmployeeId: String!, $programId: String!, $activate: Boolean!) {
        toggleActiveStatus(reviewerEmployeeId: $reviewerEmployeeId, programId: $programId, activate: $activate) {
            status
        }
    }
`;